import { UsageCondition } from '../../models/Product';
import { SubscriptionPeriodType } from '../../models/Article';

export type BulkUpdateUsageConditions = ReadonlyArray<{
    productId: string;
    sourceUsageCondition: UsageCondition;
    targetUsageCondition: UsageCondition;
    sourceSubscriptionPeriodType?: SubscriptionPeriodType;
    targetSubscriptionPeriodType?: SubscriptionPeriodType;
}>;

export function mapBulkUpdateUsageConditionsToApi(updates: BulkUpdateUsageConditions) {
    return JSON.stringify({
        updates: updates.map(u => ({
            ...u.targetUsageCondition,
            productId: u.productId,
            sourceLendingModel: u.sourceUsageCondition.lendingModel,
            sourceUsageLimit: u.sourceUsageCondition.usageLimit,
            sourceTermLimit: u.sourceUsageCondition.termLimit,
            sourceSubscriptionPeriodType: u.sourceSubscriptionPeriodType,
            targetSubscriptionPeriodType: u.targetSubscriptionPeriodType
        }))
    });
}
